<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="addOrEdit" :loading="btnLoading" v-if="!disable">保存</el-button>
      <el-button @click="surePgsu" :loading="btnLoading"  v-if="!disable">确认</el-button>
      <el-button @click="close">关闭</el-button>
      <span style="margin-left: 50px;" >项目名称：{{project.projectcode}}-{{project.projectname}}</span>
      <span v-if="disable" style="color: red;margin-left:100px;">评分已确认</span>
    </div>
    <el-table :data="pgsuList"  style="" height="400" border @cell-click="cellClick">
      <el-table-column type="index" label="行号" width="50"></el-table-column>
      <el-table-column label="供应商" prop="pgsucomname" width="100"></el-table-column>
      <el-table-column label="报价记录" width="300">
        <template slot-scope="scope">
          <div v-for="(pbr,index) in scope.row.pbrList" :key="index">
            {{pbr.pbrseq}} 时间：{{pbr.pbrtime | newDateTime}} 出价：<span style="color: red">{{pbr.pbramt}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-for="(pg,index) in pgList" :key="index" :label="pg.pgname" width="100" :index="index">
        <template slot-scope="scope">
          <div v-if="disable">
            {{scope.row.pgsuas[index].pgsuas}}
          </div>
          <div v-else>
            <span v-if="pg.pgflg === '1'">{{scope.row.pgsuas[index].pgsuas}}</span>
            <span v-if="pg.pgflg === '2' && scope.row.pgsuas[index].pgsuitems.length>0">
              <span v-if="scope.row.pgsuas[index].pgsuas">
                {{scope.row.pgsuas[index].pgsuas}}
              </span>
              <span v-else="">
                <el-button>去评分</el-button>
              </span>
            </span>
            <el-input v-if="pg.pgflg === '2' && scope.row.pgsuas[index].pgsuitems.length===0" v-model="scope.row.pgsuas[index].pgsuas" :maxlength="12" :disabled="disable"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="评审人意见" prop="">
        <template slot-scope="scope">
          <div v-if="disable">
            {{scope.row.pgsudesc}}
          </div>
          <div v-else>
            <el-input v-model="scope.row.pgsudesc" :maxlength="255" type="textarea" :disabled="disable"></el-input>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="pgsuItemList" v-if="pgsuItemList.length" style="margin-top: 20px" height="250" border>
      <el-table-column label="行号" prop="pgsuitemseq" width="50"></el-table-column>
      <el-table-column label="评分细则" prop="pgsuitemname" width="200"></el-table-column>
      <el-table-column label="分值" prop="pgsuitemss" width="100"></el-table-column>
      <el-table-column label="分项得分" prop="" width="100">
        <template slot-scope="scope">
          <div v-if="disable">
            {{scope.row.pgsuitemas}}
          </div>
          <div v-else>
            <el-input v-model="scope.row.pgsuitemas" :maxlength="12" :disabled="disable" @input="calPgsuas(scope.row)"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="评审人意见" prop="">
        <template slot-scope="scope">
          <div v-if="disable">
            {{scope.row.pgsuitemdesc}}
          </div>
          <div v-else>
            <el-input v-model="scope.row.pgsuitemdesc" :maxlength="255" type="textarea" :disabled="disable"></el-input>
          </div>
        </template>
      </el-table-column>
    </el-table>


  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "prsform",
    data () {
      return {
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: false,
        btnLoading: false,
        pgsuList: [],
        pgList: [],
        pgsuItemList: [],
        pgsu: {},
        pgIndex: -1
      }
    },
    created () {
    },
    activated() {
      this.init()
      // this.initPgsu()
      this.getPgList()
      this.getPgsuList()
    },
    watch: {
    },
    filters: {
      newDateTime (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
      },
    },
    components: {},
    computed: {
    },
    methods: {
      async init() {
        this.project = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = false
        this.btnLoading = false
        this.pgsuList = []
        this.pgList = []
        this.pgsuItemList = []
        this.pgsu = {}
        this.pgIndex = -1
      },
      async changeStatus() {
        let status = this.pgsuList[0].pgsuas[0].pgsustatus
        if (status === '2') {
          this.disable = true
        } else {
          this.disable = false
        }
      },
      async initPgsu() {
        let data = await request({
          url: '/xmgl/pgs/initPgsu',
          method: "post",
          data: {projectid: this.project.projectid,userid: this.$store.getters.loginUser.userid}
        })
        if (data.issuccess===1) {
          await this.getPgsuList()
          this.$message.success('初始化完毕！')
        } else if (data.issuccess===2) {
        } else {
          this.$message.error('初始化失败！')
        }
      },
      async cellClick(row, column, cell, event) {
        if (column.index >= 0) {
          this.pgsu = row
          this.pgIndex = column.index
          this.pgsuItemList = row.pgsuas[column.index].pgsuitems
        }
      },
      async getPgList() {
        this.pgList = await request({
          method: 'get',
          url: '/xmgl/project/getPgList',
          params: {projectid: this.project.projectid}
        })
        console.log(this.pgList)
      },
      async getPgsuList () {
        this.pgsuList = await request({
          method: 'get',
          url: '/xmgl/pgs/getPgsuList',
          params: {projectid: this.project.projectid,userid: this.$store.getters.loginUser.userid}
        })
        await this.changeStatus()
      },
      async calPgsuas(row,val2) {
        if (+row.pgsuitemas > +row.pgsuitemss) {
          this.$message.warning('分项得分不能大于分值！')
          setTimeout(() => {
            row.pgsuitemas = ''
            this.pgsu.pgsuas[this.pgIndex].pgsuas = ''
          }, 600)
          return
        }
        let score = 0
        this.pgsuItemList.forEach(item => {
          score = score+Number(item.pgsuitemas)
        })
        this.pgsu.pgsuas[this.pgIndex].pgsuas = score
      },
      async surePgsu() {
        let nullCount = 0
        let list = await request({
          method: 'get',
          url: '/xmgl/pgs/getPgsuList',
          params: {projectid: this.project.projectid,userid: this.$store.getters.loginUser.userid}
        })
        if (list.length) {
          list.forEach(v => {
            let index = v.pgsuas.findIndex(t => !t.pgsuas)
            if (index > -1) {
              nullCount += 1
            }
          })
        } else {
          nullCount = 1
        }
        if (nullCount > 0) {
          this.$message.warning('请评分点保存后再确认！')
          return
        }
        //需要增加评分是否已保存，才能确认
        let model = {
          projectid: this.project.projectid,
          pexpertid: this.$store.getters.loginUser.userpexpertid,
          userid: this.$store.getters.loginUser.userid,
          pgsuList: this.pgsuList
        }
        let data = await request({
          url: '/xmgl/pgs/surePgsu',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.disable = true
          this.$message.success('评分确认成功')
        } else {
          this.$message.error('评分确认失败')
        }
      },
      async addOrEdit () {
        console.log(this.pgsuList, 23323)
        let numsCount = 0
        if (this.pgsuList.length) {
          this.pgsuList.forEach(t => {
            if (t.pgsuas.length) {
              t.pgsuas.forEach(v => {
                if (Number(v.pgsuas) > 100) {
                  numsCount += 1
                }
              })
            }
          })
        }
        if (numsCount > 0) {
          this.$message.warning('评分不能超过100分！')
          return
        }
        let data = await request({
          url: '/xmgl/pgs/savePgsu',
          method: "post",
          data: this.pgsuList
        })
        if (data.issuccess===1) {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pgsuIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
